'use strict';

var React = require('react');
require('../../../theme/breakpoints.js');
require('imask');
var useRefAndForward = require('../../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var useValidityState = require('../../../hooks/useValidityState.js');
var component = require('../Control/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const states = ['valueMissing', 'tooShort', 'tooLong', 'customError'];
const TextInput = React.forwardRef(({ value, onChange, onValidityChange, ...props }, ref) => {
    const useValidity = useValidityState.useElementValidityState(states);
    const inputRef = useRefAndForward.useRefAndForward(null, ref);
    useValidity({ elementRef: inputRef, onValidityChange, value, required: props.required });
    return (React__default.default.createElement(component.Control, { ...props, as: "input", type: "text", value: value ?? '', onChange: (event) => onChange(event.target.value || null, event), ref: inputRef }));
});

exports.TextInput = TextInput;
exports.states = states;
//# sourceMappingURL=component.js.map
